module.exports = __webpack_public_path__ + "static/media/aborted_report.64c688ae.svg";